<template>
  <!-- DeepSea Footer START -->
  <footer class="footer" id="deepsea" v-if="deepsea">
    <div class="deepsea-footer-content">
      <section class="deepsea-footer-logo">
        <img
          src="https://deepseasandbox.wpenginepowered.com/wp-content/uploads/2025/09/deepsea-logo-white-768x121.png"
          width="0"
          height="0"
        />
      </section>
      <section class="deepsea-footer-links">
        <div class="deepsea-tm">
          DeepSea is a registered trademark of SeeScan, Inc.
        </div>
        <div class="deepsea-links">
          <!-- Quick Links -->
          <div class="deepsea-links-col">
            <h3>Quick Links</h3>
            <ul>
              <li><a href="">RMA</a></li>
              <li><a href="">About Us</a></li>
              <li><a href="">Contact Us</a></li>
              <li><a href="">FAQs</a></li>
              <li><a href="https://www.seescan.com/">SeeScan, Inc.</a></li>
            </ul>
          </div>
          <!-- Resources Links -->
          <div class="deepsea-links-col">
            <h3>Resources</h3>
            <ul>
              <li><a href="">Knowledgebase</a></li>
              <li><a href="">Product Documentation</a></li>
              <li><a href="">Warranty</a></li>
              <li><a href="">Patents</a></li>
              <li><a href="">Terms and Conditions</a></li>
            </ul>
          </div>
          <!-- Social Media Links -->
          <div class="deepsea-links-col">
            <h3>Social</h3>
            <ul>
              <li><a href="https://x.com/deepsea_pl">X</a></li>
              <li>
                <a
                  href="https://www.linkedin.com/company/deepsea-power-&-light/"
                  >LinkedIn</a
                >
              </li>
              <li>
                <a
                  href="https://www.youtube.com/channel/UCg9DG-24ffew829FNziz1Hg/videos"
                  >YouTube</a
                >
              </li>
            </ul>
          </div>
        </div>
      </section>
      <!-- DeepSea Legal START -->
      <section class="deepsea-legal">
        <p>© 2026 SeeScan. All rights reserved.</p>
        <div class="deepsea-legal-links">
          <a href="">Privacy Policy</a>
          <a href="">Terms of Service</a>
        </div>
        <!-- <Popover class="legal">
        <div class="legal-copy">
          DeepSea is a business division of SeeScan, Inc. All registered and
          unregistered trademarks and logos mentioned herein are the property of
          their respective owners. Copyright (C) 2026 SeeScan, Inc. All rights
          reserved.
        </div>
      </Popover> -->
      </section>
      <!-- DeepSea Legal END -->
    </div>
  </footer>
  <!-- DeepSea Footer END -->

  <!-- SeeScan Footer START -->
  <footer class="footer" id="seescan" v-else>
    <section>
      <h3>Our Company</h3>
      <a href="https://www.seescan.com/about-us/">About Us</a>
      <a href="https://www.seescan.com/our-history/">Our History</a>
      <a href="https://www.seescan.com/our-campus/">Our Campus</a>
      <a href="https://www.seescan.com/terms-and-conditions/">
        Terms &amp; Conditions
      </a>
      <a href="https://www.seescan.com/intellectual-property/">
        Intellectual Property
      </a>
      <a href="https://www.seescan.com/covid-19/">COVID-19</a>
    </section>
    <section>
      <h3>Careers</h3>
      <a href="https://www.seescan.com/life-at-seescan/">Life at SeeScan</a>
      <router-link to="/" :active="isActive">Job Opportunities</router-link>
      <!-- <a href="#">Job Opportunitites</a> -->
    </section>
    <section>
      <h3>Learn More</h3>
      <a href="https://www.seescan.com/knowledgebase/">Knowledgebase</a>
      <a href="https://www.seescan.com/geo-locating/">Geo Locating</a>
      <a href="https://www.seescan.com/products/">Our Products</a>
    </section>
    <section>
      <h3>Get In Touch</h3>
      <a href="https://www.seescan.com/contact_us/">Contact Us</a>
      <h3 v-if="!mobileView">Repair</h3>
      <a v-if="!mobileView" href="https://www.seescan.com/repair/"
        >Factory Direct Service</a
      >
    </section>
    <section v-if="mobileView">
      <h3>Repair</h3>
      <a href="https://www.seescan.com/repair/">Factory Direct Service</a>
    </section>
    <section class="social-media">
      <h3>Social</h3>
      <!-- social media -->
      <div class="social-media">
        <!-- Facebook -->
        <a
          href="https://www.facebook.com/SeeScan-168217610038735/"
          target="_blank"
        >
          <img
            src="https://www.seescan.com/wp-content/uploads/2019/12/Facebook-Icon.png"
            alt="Facebook"
            width="35"
            height="35"
          />
        </a>
        <!-- Instagram -->
        <a href="https://www.instagram.com/seescanofficial/" target="_blank">
          <img
            src="https://www.seescan.com/wp-content/uploads/2019/12/Instagram-Icon.png"
            alt="Instagram"
            width="35"
            height="35"
          />
        </a>
        <!-- YouTube -->
        <a
          href="https://www.youtube.com/channel/UCcAdMAULSj43y1LiiSMGIZw"
          target="_blank"
        >
          <img
            src="https://www.seescan.com/wp-content/uploads/2019/12/YouTube-Icon.png"
            alt="YouTube"
            width="35"
            height="35"
          />
        </a>
        <!-- Twitter -->
        <a href="https://twitter.com/seescan" target="_blank">
          <img
            src="https://www.seescan.com/wp-content/uploads/2023/09/Twitter-X.png"
            alt="Twitter"
            width="35"
            height="35"
          />
        </a>
        <!-- LinkedIn -->
        <a href="https://www.linkedin.com/company/seescan/" target="_blank">
          <img
            src="https://www.seescan.com/wp-content/uploads/2019/12/LinkedIn-Icon.png"
            alt="LinkedIn"
            width="35"
            height="35"
          />
        </a>
      </div>
      <!-- SeeScan Sitemap -->
      <a
        class="sitemap"
        v-if="!mobileView"
        href="https://www.seescan.com/sitemap/"
      >
        <h3>Sitemap</h3>
      </a>
    </section>
    <section v-if="mobileView">
      <a class="sitemap" href="https://www.seescan.com/sitemap/">
        <h3>Sitemap</h3>
      </a>
    </section>
  </footer>
  <!-- SeeScan Footer END -->

  <!-- DeepSea Gradient Line START -->
  <footer class="deepsea-gradient-line" v-if="deepsea"></footer>
  <!-- DeepSea Gradient Line END -->

  <!-- SeeScan Copyright START -->
  <footer class="footer-copyright seescan-copyright" v-else>
    <img
      src="https://www.seescan.com/wp-content/uploads/2020/07/Underground_Evolved_Horizontal-6_c-1.png"
      width="250px"
      height="200px"
    />
    <!-- SeeScan Legal -->
    <Popover class="legal">
      <div class="legal-copy">
        RIDGID and the RIDGID logo are trademarks of Ridge Tool Company,
        registered in the USA and other countries. All other registered and
        unregistered trademarks and logos mentioned herein are the property of
        their respective owners. Copyright © 2021 SeeScan. All rights reserved.
      </div>
    </Popover>
  </footer>
  <!-- SeeScan Copyright END -->
</template>

<script>
import Popover from '@/components/Popover.vue'
export default {
  name: 'Footer',
  components: {
    Popover,
  },
  props: {
    deepsea: {
      type: Boolean,
    },
  },
  data() {
    return {
      mobileView: false,
    }
  },
  methods: {
    handleView() {
      this.mobileView = window.innerWidth <= 1100
    },
  },
  created() {
    this.handleView()
  },
}
</script>

<style>
/*Mobile First Default */

footer#deepsea {
  background: linear-gradient(rgb(9, 86, 161) 0%, rgb(25, 43, 108) 100%);
  color: white;
  border-top: 4px solid #ffda00;
  padding: 40px 30px;
}

.deepsea-footer-content {
  margin: 0 auto;
  /* center content */
  max-width: 1400px;
}

footer#seescan {
  background: black;
  color: white;
  padding: 70px 30px 40px 30px;
}

.footer {
  display: inline-flex;
  flex-direction: column;
  width: 100%;
  margin: 0;
}

section {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
}

/* deepsea footer logo */
.deepsea-footer-logo {
  display: inline-flex;
  padding: 24px 0;
  width: 100%;
}

.deepsea-footer-logo img {
  height: auto;
  max-width: 250px;
  width: 50%;
}

.deepsea-footer-links {
  display: inline-flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 2rem;
}

.deepsea-tm {
  text-align: left;
}

.deepsea-links {
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  gap: 2rem;
  margin-block-start: 4rem;
}

.deepsea-links-col ul {
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  gap: 1.2rem;
  margin-block-start: 1.2rem;
}

#deepsea h3,
#deepsea a {
  color: white;
  margin: 0;
  font-size: 1em;
}

#seescan h3 {
  color: #f2f2f2;
}

#seescan a {
  color: #999999;
}

#seescan a {
  font-size: 0.875em;
  margin-block-start: 0.4em;
  margin-block-end: 0.4em;
}

/* states */
#seescan a:hover,
#seescan a:active,
#seescan a:focus {
  color: #59ea62;
  text-decoration: none;
  font-weight: bold;
}

#deepsea a:hover,
#deepsea a:active,
#deepsea a:focus {
  color: white;
  text-decoration: underline;
}

/* social media */
.social-media {
  display: inline-flex;
}

.social-media a img {
  margin: 10px 10px 0 0;
}

a.sitemap {
  font-size: unset;
}

/* DeepSea Legal */
.deepsea-legal {
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  width: 100%;
  font-size: 14px;
  gap: 1rem;
}

.deepsea-legal-links {
  display: flex;
  gap: 1rem;
}

.legal-copy {
  padding: 0.75em 1em;
}

.deepsea-gradient-line {
  border-bottom: 20px solid transparent;
  border-image: linear-gradient(90deg, #0956a1 0%, #39d52d 100%) 1;
}

.seescan-copyright {
  background-color: #000000;
  border-top: 1px solid #59ea62;
}

.footer-copyright {
  padding: 16px 30px;
  display: inline-flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  width: 100%;
}

.footer-copyright img {
  height: auto;
  max-width: 250px;
  width: 50%;
}

.footer-copyright .legal {
  font-size: 11px;
  color: white;
  cursor: pointer;
}

.footer-copyright .legal .legal-copy {
  padding: 0.75em 1em;
  color: #747474;
  font-size: 13px;
  line-height: 18px;
}

@media screen and (min-width: 1100px) {
  .deepsea-legal {
    flex-flow: row nowrap;
  }

  .deepsea-links {
    flex-direction: row;
    gap: 4rem;
    margin-block-start: 0;
  }

  .deepsea-footer-links {
    flex-direction: row;
  }

  .footer#seescan {
    flex-direction: row;
    padding: 70px;
  }

  .footer-copyright {
    padding-left: 70px;
    padding-right: 70px;
  }

  section {
    width: 20%;
  }

  .social-media {
    flex-wrap: wrap;
  }
}
</style>
